import { CartUpdatedEvent } from '@theme/events';

class CartGiftSelector extends HTMLElement {
  connectedCallback() {
    this.#removeInvalidGifts();
    this.#bindEvents();
  }

  async #removeInvalidGifts() {
    const giftsToRemove = this.dataset.giftsToRemove;
    if (!giftsToRemove) return;

    const keys = giftsToRemove.split(',').filter(Boolean);
    if (keys.length === 0) return;

    this.#setLoading(true);

    const sectionId = this.#getSectionId();

    for (let i = 0; i < keys.length; i++) {
      const isLast = i === keys.length - 1;
      const body = { id: keys[i], quantity: 0 };

      if (isLast) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(Theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });

        if (isLast) {
          const data = await response.json();
          document.dispatchEvent(
            new CartUpdatedEvent(
              {},
              {
                itemCount: data.item_count,
                source: 'cart-gift-selector',
                sections: data.sections,
              },
            ),
          );
        }
      } catch (e) {
        console.error('CartGiftSelector: error removing invalid gift', e);
      }
    }

    this.#setLoading(false);
  }

  #bindEvents() {
    this.querySelectorAll('[data-action="add"]').forEach((btn) => {
      btn.addEventListener('click', () => this.#addGift(btn.dataset.variantId, btn.dataset.tier));
    });

    this.querySelectorAll('.cart-gift__product--with-select').forEach((card) => {
      const select = card.querySelector('.cart-gift__variant-select');
      const addBtn = card.querySelector('[data-action="add-from-select"]');
      if (select && addBtn) {
        select.addEventListener('change', () => {
          addBtn.disabled = !select.value;
        });
      }
    });

    this.querySelectorAll('[data-action="add-from-select"]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const select = btn.closest('.cart-gift__product--with-select').querySelector('.cart-gift__variant-select');
        if (select && select.value) {
          this.#addGift(select.value, btn.dataset.tier);
        }
      });
    });
  }

  async #addGift(variantId, tier) {
    this.#setLoading(true);
    this.#closeTierModal(tier);

    const sectionId = this.#getSectionId();

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1, properties: { _gift_tier: tier, _is_gift: 'true' } }],
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      document.dispatchEvent(
        new CartUpdatedEvent(
          {},
          {
            itemCount: data.item_count || null,
            source: 'cart-gift-selector',
            sections: data.sections,
          },
        ),
      );
    } catch (e) {
      console.error('CartGiftSelector: error adding gift', e);
      this.#setLoading(false);
    }
  }

  #closeTierModal(tier) {
    if (!tier) return;
    const popup = this.querySelector(`dialog-component[data-tier="${tier}"]`);
    if (popup && typeof popup.close === 'function') popup.close();
  }

  #getSectionId() {
    const cartDrawer = this.closest('cart-drawer');
    return cartDrawer ? cartDrawer.dataset.sectionId : this.dataset.sectionId;
  }

  #setLoading(loading) {
    this.classList.toggle('cart-gift--loading', loading);
  }
}

if (!customElements.get('cart-gift-selector')) {
  customElements.define('cart-gift-selector', CartGiftSelector);
}
